// Style
import 'src/style/style.scss';
import "src/scripts/run";
import index from "src/scripts/index";

console.log("live");



const data = { "clientDomainName": window.location.hostname !== "localhost" ? window.location.hostname : "kongsbergshistorie.no" };


fetch('https://rolemanager.prokom.no/api/admin/organization/getclientbydomain', { //
      method: 'POST', // or 'PUT'
      headers: {
            'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
})
      .then(response => response.json())
      .then(data => {

            if (data.result) {


                  window.config = data.result;
                  // window.aimMeta = JSON.parse(data.result.applications[0].metaData).aim;

                  index();




            }

      });
